import { ICommentResponse } from '../../../../types/order/comment/IComment';
import { prettyCommentsType } from '../../../../types/order/comment/eCommentType';
import { ICommentTableEntry } from '../CommentsTable';

export const convertICommentResponseToICommentTableEntry = ({
  id,
  createdAt,
  type,
  author,
  content,
}: ICommentResponse): ICommentTableEntry => {
  return {
    id,
    datePosted: createdAt,
    commentType: type,
    commentTypeDisplay: (type && prettyCommentsType[type]) ?? '',
    postedBy: author.fullName,
    content,
  };
};
